import classNames from 'classnames';
import React, { useContext } from 'react';

import { Anchor } from '@zooplus/ui-components';

import AppContext from '../../context';
import { UiCategory } from '../../types';
import { convertTrackingIdTitle } from '../../utils/categoryUtils';
import { LinkTypeEnum } from '../Link/Link';

import styles from './CategoryFlyout.module.scss';

const AnimalFlyout = ({ category }: { category: UiCategory }): JSX.Element => {
    const { path, children, specials, title } = category;
    const groupedItems: UiCategory[] = [];
    const restItems: UiCategory[] = [];
    const { translations } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');

    children?.forEach((child) => {
        if (child.children?.length) {
            groupedItems.push(child);
        } else {
            restItems.push(child);
        }
    });

    return (
        <div className={classNames(styles.animalflyout, styles.scrollBox)}>
            <div className={styles.flyOutHeader}>
                <Anchor
                    href={path}
                    data-link-type={LinkTypeEnum.PRIMARY}
                    data-zta="category-flyout-animal-level2-link">
                    {viewAllLabel} {title}
                </Anchor>
            </div>
            <div className={styles.animalPanel}>
                {groupedItems?.map((main, index) => (
                    <ul
                        id={`header-category-flyout-animal-level4-links-${convertTrackingIdTitle(
                            title,
                        )}-${index}-${convertTrackingIdTitle(main.title)}`}
                        className={styles.animalPanelGroup}
                        key={main.title}>
                        <li className={styles.groupHeader}>
                            <Anchor
                                variant={LinkTypeEnum.NEUTRAL}
                                data-link-type={LinkTypeEnum.NEUTRAL}
                                data-zta="category-flyout-animal-group-header"
                                aria-label="group-header"
                                href={main.path}>
                                {main.title}
                            </Anchor>
                        </li>
                        {main.children?.map((item) => (
                            <li key={item.title} className={styles.groupItem}>
                                <Anchor
                                    variant={
                                        item.highlighted
                                            ? 'danger'
                                            : LinkTypeEnum.NEUTRAL
                                    }
                                    data-link-type={
                                        item.highlighted
                                            ? LinkTypeEnum.OFFER
                                            : LinkTypeEnum.NEUTRAL
                                    }
                                    className={classNames({
                                        [styles.nonBoldSpecialsText]:
                                            item.highlighted,
                                    })}
                                    data-zta="category-flyout-animal-level4-link"
                                    aria-label="group-header"
                                    href={item.path}>
                                    {item.title}
                                </Anchor>
                            </li>
                        ))}
                        <li className={styles.groupFooter}>
                            <Anchor
                                data-link-type={LinkTypeEnum.PRIMARY}
                                data-zta="category-flyout-animal-group-footer"
                                aria-label="group-footer"
                                href={main.path}>
                                {translations.get(
                                    'shop.header.categories.all.products.link',
                                )}
                            </Anchor>
                        </li>
                    </ul>
                ))}
                <ul
                    className={styles.animalPanelGroup}
                    id={`header-category-flyout-animal-level3-links-${convertTrackingIdTitle(
                        title,
                    )}`}>
                    {restItems?.map((item) => (
                        <li key={item.title} className={styles.groupLargeItem}>
                            <Anchor
                                variant={
                                    item.highlighted
                                        ? 'danger'
                                        : LinkTypeEnum.NEUTRAL
                                }
                                data-link-type={
                                    item.highlighted
                                        ? LinkTypeEnum.OFFER
                                        : LinkTypeEnum.NEUTRAL
                                }
                                className={classNames({
                                    [styles.nonBoldSpecialsText]:
                                        item.highlighted,
                                })}
                                data-zta="category-flyout-animal-level3-link"
                                href={item.path}>
                                {item.title}
                            </Anchor>
                        </li>
                    ))}
                </ul>
                <ul
                    className={styles.animalPanelGroup}
                    id={`header-category-flyout-animal-special-offer-links-${convertTrackingIdTitle(
                        title,
                    )}`}>
                    {specials?.map((item) => (
                        <li key={item.title} className={styles.groupLargeItem}>
                            <Anchor
                                className={styles.nonBoldSpecialsText}
                                variant="danger"
                                data-link-type={LinkTypeEnum.OFFER}
                                data-zta="category-flyout-animal-special-offer-link"
                                href={item.path}>
                                {item.title}
                            </Anchor>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default AnimalFlyout;
